import type { CampaignPayment, PaymentLineItem, PaymentStatus } from '../../types/checkout.types';

const PLACEMENT_LABELS: Record<string, string> = {
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
  GOOGLE: 'Google',
  TWITTER: 'X',
  TIKTOK: 'TikTok',
};

export function formatCents(cents: number, currency = 'usd'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(cents / 100);
}

export function placementLabel(placement: string): string {
  return PLACEMENT_LABELS[placement] ?? placement;
}

export function totalDiscountCents(lineItems: PaymentLineItem[]): number {
  return lineItems.reduce((sum, item) => sum + item.discountCents, 0);
}

/** A hold that can still be captured or released. */
export function isOpenHold(payment: CampaignPayment | null | undefined): boolean {
  return payment?.status === 'AUTHORIZED';
}

export const PAYMENT_STATUS_COPY: Record<
  PaymentStatus,
  { label: string; variant: 'success' | 'warning' | 'error' | 'info' | 'neutral' }
> = {
  PENDING: { label: 'Waiting for card', variant: 'warning' },
  AUTHORIZED: { label: 'Held on card', variant: 'info' },
  CAPTURE_PENDING: { label: 'Capturing', variant: 'info' },
  CAPTURED: { label: 'Charged', variant: 'success' },
  CANCELED: { label: 'Released', variant: 'neutral' },
  EXPIRED: { label: 'Expired', variant: 'neutral' },
  FAILED: { label: 'Failed', variant: 'error' },
};
